export const figure22 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    marginLeft: 100,
    spacingBottom: 45,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'column',
    height: '400px',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },
  title: {
      text: null
  },
  subtitle: {
      text: null
  },
  credits: {
    enabled: false
  },
  legend: {
    enabled: false,
  }, 
  exporting: {
    enabled: false
  },
  colors: ['#ffc000', '#ffc000'],
  xAxis: {
      categories: [
  "1995",
  "2000",
  "2005",
  "2010",
  "2014",
  "2015*",		   
  "2016",
  "2017",
  "2018",
  "2019",
  "2020",
  "2021",
  ],
      crosshair: true
  },
  yAxis: {
      max: 6,
      min: 0,
      tickInterval: 1,
      format: '{value.million} KK',
      title: {
          text: 'بالملايين'
      }
  },
  tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.6f}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true,
      valuePrefix: 'KK',
  },
  plotOptions: {
      column: {
          pointPadding: 0.2,
          borderWidth: 0
      }
  },
  series: [
  {
      name: '',
      data: [
	     3.121009,
	     3.556392,
	     4.368699,
	     4.997467,
	     5.355161,
	     5.421221,
	     5.487281,
	     5.537312,
	     5.680008,
	     5.750376,
	     5.769974,
	     5.830177,
        ]
  
  },
  ]
}
